import BaseListagem from "components/BaseListagem";
import { Column } from "primereact/column";
import HorarioService from "service/gestao/atividades/HorarioService";

const horarioService = new HorarioService();

export default function HorarioListagem() {

    return (

        <BaseListagem ordenacao="nome,ASC" service={horarioService} urlService="/horario" tituloPagina={'Horários'} >
            <Column field="nome" header="Nome" />
        </BaseListagem>
    )
}
